/* * Copyright 2017-2019 Amazon.com, Inc. or its affiliates. All Rights
Reserved. * * Licensed under the Apache License, Version 2.0 (the "License").
You may not use this file except in compliance with * the License. A copy of the
License is located at * * http://aws.amazon.com/apache2.0/ * * or in the
"license" file accompanying this file. This file is distributed on an "AS IS"
BASIS, WITHOUT WARRANTIES OR * CONDITIONS OF ANY KIND, either express or
implied. See the License for the specific language governing permissions * and
limitations under the License. */

<template>
  <v-container fluid grid-list-lg ma-0 pa-0>
    <!--  <div v-if="isPhoneNumberRequired">
      {{ $Amplify.I18n.get("Phone number") }} *
    </div>
    <div v-else>
      {{ $Amplify.I18n.get("Phone number") }}
    </div> -->
    <v-layout wrap>
      <v-flex xs6>
        <ValidationProvider
          ref="countryCodeInput"
          name="countries"
          :rules="composeRuleValidator(required, null)"
          v-slot="{ errors, valid }"
        >
          <v-select
            v-model="countryCode"
            :items="countries"
            item-value="value"
            item-text="label"
            :label="
              `${$Amplify.I18n.get('Country Code')} ${
                isPhoneNumberRequired ? '*' : ''
              }`
            "
            v-on:change="emitPhoneNumberChanged"
            data-test="dial-code-select"
            :error-messages="errors"
            :success="required || !!+attachRule ? valid : false"
          ></v-select>
        </ValidationProvider>
      </v-flex>
      <v-flex xs6>
        <ValidationProvider
          :name="`${$Amplify.I18n.get('Phone number')}`"
          :rules="composeRuleValidator(required, attachRule)"
          v-slot="{ errors, valid }"
        >
          <v-text-field
            type="tel"
            v-model="local_phone_number"
            :label="
              `${$Amplify.I18n.get('Phone number')} ${
                isPhoneNumberRequired ? '*' : ''
              }`
            "
            :placeholder="$Amplify.I18n.get(getPlaceholder)"
            v-on:keyup="emitPhoneNumberChanged"
            v-bind:data-test="auth.genericAttrs.phoneNumberInput"
            :error-messages="errors"
            :success="required || !!+attachRule ? valid : false"
          >
          </v-text-field>
        </ValidationProvider>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import countries from "../../assets/countries";
import { auth } from "aws-amplify-vue/src/assets/data-test-attributes";
import { Validator, ValidationProvider } from "vee-validate";
import { composeRule } from "./common";

Validator.extend("firstnotzero", {
  getMessage: () => "El primer número no debe ser 0",
  validate: value => {
    return value.slice(0, 1) == "0" ? false : true;
  }
});

export default {
  name: "PhoneField",
  components: {
    ValidationProvider
  },
  props: [
    "required",
    "attachRule",
    "invalid",
    "placeholder",
    "defaultCountryCode"
  ],
  data() {
    return {
      countryCode: this.defaultCountryCode || "1",
      local_phone_number: "",
      countries,
      auth
    };
  },
  computed: {
    isPhoneNumberRequired() {
      return this.required;
    },
    getPlaceholder() {
      return this.placeholder || "Enter your phone number";
    }
  },
  methods: {
    emitPhoneNumberChanged() {
      this.$emit("phone-number-changed", {
        countryCode: this.countryCode,
        local_phone_number: this.local_phone_number
      });
    },
    composeRuleValidator: function(required, attachRule) {
      return composeRule(required, attachRule);
    }
  },
  mounted() {
    if (this.required) {
      const provider = this.$refs["countryCodeInput"];
      // Validate the field
      return provider.validate();
    }
  }
};
</script>
